export const store = {
    _origin: 'https://api.emailjs.com',
};
